import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, ButtonGroup, Modal} from 'react-bootstrap'
import cx from 'classnames'
import cache from '../../core/cache'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import {connectWizard} from '../../core/wizard'
import {phonesField} from '../../core/phonez'
import LoaderButton from '../../core/components/LoaderButton'
import ButtonToggle from '../../core/components/ButtonToggle'
import MultiInput from '../../core/components/MultiInput'
import CompanyPicker from '../../company/components/CompanyPicker'
import {ADD_PROVIDER_CONTACT_CMD_UPDATED, REFERENCE_PROVIDER_COMPANY_CMD_UPDATED, sendAddProviderContactCmd, updateAddProviderContactCmd, sendReferenceProviderCompanyCmd, loadContactStream} from '../actions'
import {createValidator, AddProviderContactCmd, ReferenceProviderCompanyCmd} from '../models'
import i18n from '../i18n'
import ProviderPicker from './ProviderPicker'
import style from './AddProviderContactModal.less'

const WIZARD_STEPS = [2, 3.1]
const WIZARD_STEPS_COMPANY = [1, 2, 3.1]

const schemaCache = cache()

function selectSchema(cmd, {wizard}) {
    const schema = AddProviderContactCmd.selectSchema(cmd)

    return schemaCache([schema, wizard.activeStep], () => {
        if (wizard.matchActiveStep(1)) {
            return {
                ...schema,
                properties: {
                    companyUid: schema.properties.companyUid
                },
                required: ['companyUid']
            }
        }
        if (wizard.matchActiveStep([2, 3.2])) {
            return {
                ...schema,
                properties: {
                    namez: schema.properties.namez,
                    emails: schema.properties.emails,
                    phones: schema.properties.phones,
                    fax: schema.properties.fax,
                    companyUid: schema.properties.companyUid
                },
                required: ['namez', 'companyUid']
            }
        }
        return schema
    })
}

function selectSteps({authenticated}) {
    const company = getUserCompany(authenticated)
    return company && WIZARD_STEPS || WIZARD_STEPS_COMPANY
}

function getUserCompany(user) {
    switch(user.userType) {
        case 'callCenterUser':
        case 'superUser':
            return undefined
        default:
            return user.company
    }
}

class AddProviderContactModal extends Component {
    static propTypes = {
        onHide: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, addProviderContactCmd, authenticated} = this.props

        const company = getUserCompany(authenticated)

        dispatch(updateAddProviderContactCmd({
            namez: addProviderContactCmd && addProviderContactCmd.namez || {nameType: 'CivilName'},
            companyUid: company
        }))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.authenticated != this.props.authenticated) {
            const {dispatch, addProviderContactCmd, authenticated} = nextProps

            const company = getUserCompany(authenticated)

            dispatch(updateAddProviderContactCmd({
                namez: addProviderContactCmd && addProviderContactCmd.namez || {nameType: 'CivilName'},
                companyUid: company
            }))
        }
    }

    _sendCmd() {
        const {dispatch, wizard, onHide} = this.props
        const steps = this.state

        if (wizard.matchActiveStep(0.1)) {
            return dispatch(sendAddProviderContactCmd()).then(() => {
                return dispatch(loadContactStream())
            }).then(() => {
                onHide()
            })
        }

        if (wizard.matchActiveStep(0.2)) {
            return dispatch(sendReferenceProviderCompanyCmd()).then((action) => {
                const providerId = action.events.find((e) => e.eventType == 'ProviderCompanyReferenced').aggregateUid
                return dispatch(sendAddProviderContactCmd(providerId))
            }).then(() => {
                return dispatch(loadContactStream())
            }).then(() => {
                onHide()
            })
        }
    }

    _isValid() {
        const {addProviderContactForm, referenceProviderCompanyForm, wizard} = this.props

        switch (wizard.activeStep) {
            case 1: case 2: case 3.1: return addProviderContactForm.isValid()
            case 3.2: return addProviderContactForm.isValid() && referenceProviderCompanyForm.isValid()
        }
    }

    _validate() {
        const {addProviderContactForm, referenceProviderCompanyForm, wizard} = this.props

        switch (wizard.activeStep) {
            case 1: case 2: case 3.1: return addProviderContactForm.validate()
            case 3.2: return addProviderContactForm.validate() && referenceProviderCompanyForm.validate()
        }
    }

    render() {
        const {dispatch, onHide, addProviderContactForm, addProviderContactCmd, referenceProviderCompanyForm, referenceProviderCompanyCmd, wizard, ...others} = this.props

        const requiredLabel = (label) => (
            <span>{label} <i>*</i></span>
        )

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.newProviderContact}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {wizard.matchActiveStep(1) && (
                        <CompanyPicker
                            {...addProviderContactForm.companyUid()}/>
                    )}
                    {wizard.matchActiveStep(2) && (
                        <form className='form-horizontal'>
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='select'
                                name='nameType'
                                label={i18n.nameType}
                                {...addProviderContactForm.namez.nameType()}>
                                <option value='CivilName'>{i18n.nameTypeEnum.civilName}</option>
                                <option value='PoorName'>{i18n.nameTypeEnum.poorName}</option>
                            </Input>
                            {addProviderContactForm.namez.firstName && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='firstName'
                                    label={requiredLabel(i18n.firstName)}
                                    {...addProviderContactForm.namez.firstName()} />
                            )}
                            {addProviderContactForm.namez.lastName && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='lastName'
                                    label={requiredLabel(i18n.lastName)}
                                    {...addProviderContactForm.namez.lastName()} />
                            )}
                            {addProviderContactForm.namez.gender && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='select'
                                    name='gender'
                                    label={i18n.gender}
                                    {...addProviderContactForm.namez.gender()}>
                                    <option value=''></option>
                                    <option value='Male'>{i18n.genderEnum.male}</option>
                                    <option value='Female'>{i18n.genderEnum.female}</option>
                                </Input>
                            )}
                            {addProviderContactForm.namez.value && (
                                <Input
                                    labelClassName='col-sm-3'
                                    wrapperClassName='col-sm-9'
                                    type='text'
                                    name='name'
                                    label={requiredLabel(i18n.name)}
                                    {...addProviderContactForm.namez.value()} />
                            )}
                            <MultiInput
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='text'
                                name='phone'
                                label={i18n.phone}
                                {...phonesField(addProviderContactForm.phones())} />
                            <MultiInput
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='text'
                                name='fax'
                                label={i18n.fax}
                                {...phonesField(addProviderContactForm.fax())} />
                            <MultiInput
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='text'
                                name='email'
                                label={i18n.email}
                                {...addProviderContactForm.emails()} />
                        </form>
                    )}
                    {wizard.matchActiveStep(3) && (
                        <div className={style.switch}>
                            <ButtonToggle
                                value={wizard.minorActiveStep}
                                onChange={(s) => s && wizard.setActiveStep(s)}>
                                <ButtonGroup>
                                    <Button
                                        bsSize='small'
                                        value={0.1}>
                                        {i18n.selectProvider}
                                    </Button>
                                    <Button
                                        bsSize='small'
                                        value={0.2}>
                                        {i18n.newProvider}
                                    </Button>
                                </ButtonGroup>
                            </ButtonToggle>
                        </div>
                    )}
                    {wizard.matchActiveStep(3.1) && (
                        <ProviderPicker
                            {...addProviderContactForm.providerCompanyUid()} />
                    )}
                    {wizard.matchActiveStep(3.2) && (
                        <form className='form-horizontal'>
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='text'
                                name='label'
                                label={requiredLabel(i18n.label)}
                                {...referenceProviderCompanyForm.label()} />
                            <Input
                                labelClassName='col-sm-3'
                                wrapperClassName='col-sm-9'
                                type='text'
                                name='siret'
                                label={requiredLabel(i18n.siret)}
                                {...referenceProviderCompanyForm.siretNumber()} />
                        </form>
                    )}
                    <ButtonToolbar>
                        {!wizard.hasNextStep() && (
                            <LoaderButton
                                bsStyle='primary'
                                bsSize='large'
                                className={cx({disabled: !this._isValid()})}
                                onClick={() => this._validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                                {i18n.save}
                            </LoaderButton>
                        )}
                        {wizard.hasPreviousStep() && (
                            <Button
                                bsSize='large'
                                onClick={(e) => wizard.previousStep()}>
                                previous
                            </Button>
                        )}
                        {wizard.hasNextStep() && (
                            <Button
                                bsSize='large'
                                className={cx({disabled: !this._isValid()})}
                                onClick={() => this._validate() && (wizard.nextStep() || true) || dispatch(errorStatus(i18n.formInvalid))}>
                                next
                            </Button>
                        )}
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

AddProviderContactModal = connectForm({
    name: 'referenceProviderCompanyForm',
    alias: 'cmd',
    target: 'referenceProviderCompanyCmd',
    schema: ReferenceProviderCompanyCmd.schema,
    action: REFERENCE_PROVIDER_COMPANY_CMD_UPDATED
})(AddProviderContactModal)

AddProviderContactModal = connectForm({
    validator: createValidator(),
    name: 'addProviderContactForm',
    alias: 'cmd',
    target: 'addProviderContactCmd',
    schema: selectSchema,
    action: ADD_PROVIDER_CONTACT_CMD_UPDATED
})(AddProviderContactModal)

AddProviderContactModal = connectWizard({
    steps: selectSteps
})(AddProviderContactModal)

AddProviderContactModal = connect((state) => ({
    authenticated: state.user.authenticated,
    addProviderContactCmd: state.provider.addProviderContactCmd,
    referenceProviderCompanyCmd: state.provider.referenceProviderCompanyCmd
}))(AddProviderContactModal)

export default AddProviderContactModal


// WEBPACK FOOTER //
// ./lib/provider/components/AddProviderContactModal.js